<template>
  <div class="col-12 page_content_area">
    <div class="container enterprises_register_content_area">
      <div class="row mb-5 justify-content-center">
        <div class="col-12 col-sm-10">
          <enterprise-job-opening-form
            bg-color="gray"
            :current-job="currentEnterpriseJobGetter"
            @submit="submitJobOpening"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  mapActions,
  mapGetters
} from 'vuex'
import EnterpriseJobOpeningForm from './EnterpriseJobOpeningForm'
export default {
  name: 'EnterprisesJobOpeningsContent',
  components: {
    EnterpriseJobOpeningForm
  },
  computed: {
    ...mapGetters('pages/enterprises', [
      'currentEnterpriseJobGetter'
    ])
  },
  async created () {
    if (this.$route.params.id) {
      try {
		await this.getCurrentEnterpriseJobById(this.$route.params.id)
	  } catch (err) {
		this.$router.push('/enterprises');
	  }
    }
  },
  methods: {
    ...mapActions('pages/enterprises', [
      'getCurrentEnterpriseJobById',
      'createJobOpening',
      'updateJobOpening'
    ]),
    async submitJobOpening (job) {
      if (this.$route.params.id) {
        await this.updateJobOpening({
          id: this.$route.params.id,
          job
        })
      } else {
        await this.createJobOpening(job)
      }
      this.$router.push({
        path: '/enterprises',
        query: {
          tab: '職缺管理'
        }
      })
    }
  }
}
</script>
